import { Outlet } from "react-router-dom";
import NavTabs from "../../ui/NavTabs";
import { partnerstvoTabs } from "../../../config/navItemsProjectsDetailsV2";

const Partnerstvo = () => {
  return (
    <div>
      <div className="mb-3">
        <NavTabs listOfTabs={partnerstvoTabs} />
        <div className="mt-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Partnerstvo;
